import React, { Component } from 'react';
import { Card, Input, Table, Popover, Popconfirm, Timeline, Icon, message, Tooltip, Button, Modal, Empty } from 'antd';
import { deleteByStuff, getMaterialList } from "../../actions/weiChat";
import { uuid } from "../../utils";
import "./publishRecord.scss";
import ContentModal from "../contentModal";
import time from './images/time.png';
import del from './images/delete.png';
import Scrollbars from 'react-custom-scrollbars';
import BaseComponent from "../../base/BaseComponent";

const { Search } = Input;

class PublishRecord extends BaseComponent {

    columns = [
        {
            title: '发布内容',
            dataIndex: 'name',
            key: 'name',
            width:'80%',
            render: (text, record) => (
                <div style={{width:1100}}>
                <ContentTd removeStuff={this.removeStuff.bind(this)} {...record} /></div>
            ),
            className: 'column1'
        },
        { title: '发布进度',
            dataIndex: 'id',
            render: (text, record) => (
                <div style={{width:'100%',height:'100%',display:'flex'}}>
                    <Popover placement="bottom" title={null} content={this.getPopoverContent(record)} >
                        <Icon style={{margin:'auto',fontSize:18}} type="calendar" />
                        {/*<Button style={{margin:'auto',}} onClick={()=>{this.getPopoverContent(record)}}>发布进度</Button>*/}
                    </Popover>
                </div>
            ),
        },
        {
            title: '操作',
            key: 'action',
            render: (text, record) => {
                let showExplorBtn = record.stuffList.length - 1 !== 0;
                let btnName = record.showStuffList ? "收起" : "展开";
                let fold = record.showStuffList ? true : false
                //let btnName = "查看发布"
                return (
                    !showExplorBtn ? "" :
                        <>

                            <div className={`other ${fold ? 'fold' : 'expand'}`} style={{ fontFamily: 'MicrosoftYaHei-Bold', color: '#8792b3', fontWeight: 'bolder', cursor: 'pointer' }} onClick={() => this.updateShowStatus(record)}>{btnName}</div></>


                    // <Button icon={record.showStuffList?"up":"down"} style={{background:record.showStuffList? "#fff":"#eae8e8fa",height:"25px"}}//position: "absolute", bottom: "0px", left: "55px",
                    //         onClick={()=>this.updateShowStatus(record)}>
                    //     {btnName}
                    // </Button>
                )
            },
            width: '200px',
            className: 'column2',
            align: 'center'
        },
    ];

    updateShowStatus = (record) => {
        record.showStuffList = !record.showStuffList;
        this.setState({
            exploreStuff: new Date().getTime(),
        })
    };

    removeStuff(stuff) {
        this.setState(prevState => {
            prevState.data.map(material => {
                material.stuffList = material.stuffList.filter(oldStuff => oldStuff.id !== stuff.id);
            });
            return prevState;
        })
    }

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            exploreStuff: 1,
            data: []
        }
    }

    params = {
        start: 1,
        size: 10,
        queryStr: "",
        mediaId: this.props.match.params.currentMedia
    };

    /**
     * 组装发布进度信息
     * @param index
     * @returns {*}
     */
    getPopoverContent(record) {
        let timeList = [];
        if (record.publishStatus) {
            if (record.publishStatus.processStatus.length > 0) {
                for (let i = 0; i < record.publishStatus.processStatus.length; i++) {
                    let temp = this.transformTimeLineItem(record.publishStatus.processStatus[i]);
                    timeList.push(this.renderingPublishStatusTimeLineItem(temp));
                }
                return <div><Timeline>
                    {timeList.map(item => item)}
                </Timeline> </div>;
            }
        } else if (record.statusName === '发布' && record.publishStatus && record.publishStatus.status === 2) {
            for (let i = 0; i < record.publishStatus.processStatus.length; i++) {
                let temp = this.transformTimeLineItem(record.publishStatus.processStatus[i]);
                timeList.push(this.renderingPublishStatusTimeLineItem(temp));
            }
            return <div><Timeline>
                {timeList.map(item => item)}
            </Timeline> </div>;
        } else {
            return <div>未查询到发布进度</div>;
        }
    }

    /* 解析发布状态 */
    transformTimeLineItem(str) {
        //模板     "[2019-12-01 17:00:37]开始发布至xx网站/校园新闻",
        //         "[2019-12-01 17:00:38]发布至xx网站/校园新闻成功",
        //         "[2019-12-01 17:00:38]正在发布融媒APP",
        //         "[2019-12-01 17:00:38]发布至融媒APP成功"
        let item = {};
        if (str.indexOf("[") > -1 && str.indexOf("]") > -1) {
            item.time = str.substring(str.indexOf("[") + 1, str.indexOf("]") - 1);
            item.content = str.substring(str.indexOf("]") + 1);
            if (str.indexOf("开始") === str.indexOf("]") + 1) {
                item.type = "start";
            } else if (str.indexOf("正在") === str.indexOf("]") + 1) {
                item.type = "doing";
            } else if (str.indexOf("成功") === str.length - 2) {
                item.type = "ok";
            } else if (str.indexOf("失败") > -1) {
                item.type = "error";
            }
        } else {
            item.type = "none";
            item.time = "";
            item.content = str;
        }
        return item;
    }

    /* 渲染发布状态 */
    renderingPublishStatusTimeLineItem(item) {
        if (item.type === "none") {
            return <Timeline.Item>
                <p>{item.content}</p>
            </Timeline.Item>;
        } else if (item.type === "start") {
            return <Timeline.Item >
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        } else if (item.type === "doing") {
            return <Timeline.Item dot={<Icon type="clock-circle-o" style={{ fontSize: '16px' }} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        } else if (item.type === "ok") {
            return <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        } else if (item.type === "error") {
            return <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        } else {
            return <Timeline.Item dot={<Icon type="clock-circle-o" style={{ fontSize: '16px' }} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        }
    }

    componentDidMount() {
        this.initData();
    }

    initData = () => {
        this.setState({
            loading: true
        });
        let params = { ...this.params };
        params.tabType = "published";
        this.request({
            url: '/cm-sites-pms/material/pageList',
            body: params,
            callBack: (res) => {
                this.setState(prevState => {
                    prevState.data = res.data;
                    res.data.map(item => item.showStuffList = false);
                    prevState.loading = false;
                    return prevState;
                });
            }
        });
        // getMaterialList(params, (res) => {
        //     this.setState(prevState => {
        //         prevState.data = res.data;
        //         res.data.map(item => item.showStuffList = false);
        //         prevState.loading = false;
        //         return prevState;
        //     });
        // })
    };

    pageChange = (page, pageSize) => {
        this.params.start = page;
        this.params.size = pageSize;
        this.initData();
    };

    search = (value) => {
        this.params.queryStr = value;
        this.params.start = 1;
        this.params.size = 10;
        this.initData();
    };



    render() {
        return (
            <div className="group-message" style={{ height:'calc(100vh - 100px)',margin:'15px 0 0 15px',borderRadius:'5px'}}>
                <div className="group-message-title">
                    已群发消息
                </div>
                <div className="search">
                    <Search placeholder="请输入搜索内容" onSearch={value => this.search(value)} style={{ width: '300px' }} />
                </div>
                <div className="content">

                    <Scrollbars >
                        {
                            this.state.data && this.state.data.length > 0 ?
                                <Table columns={this.columns}
                                    showHeader={false}
                                    pagination={{
                                        showQuickJumper: true,
                                        current: this.params.start,
                                        onChange: this.pageChange,
                                        style: { marginRight: '20px' },
                                        showSizeChanger: true,
                                        pageSizeOptions: ['10', '20', '30', '40', '50'],
                                        onShowSizeChange: this.onShowSizeChange
                                    }}
                                    loading={this.state.loading}
                                    dataSource={this.state.data}
                                    className="group-message-table"
                                    rowClassName="group-message-table-select-row"
                                    locale={{ emptyText: " " }}
                                /> : <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Empty /></div>
                        }

                    </Scrollbars>
                </div>
            </div>
        );
    }
}

class ContentTd extends Component {

    constructor(props) {
        super(props);
        this.state = {
            stuffList: props.stuffList,
            showStuffList: props.showStuffList,
            contentModalVisible: false,
            materialId: props.id,
            viewStuffId: 0
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            stuffList: nextProps.stuffList,
            showStuffList: nextProps.showStuffList
        })
    }

    deleteStuff = (item) => {
        deleteByStuff({ "materialId": item.materialId, "stuffId": item.id }, (res) => {
            if (res.code === 0) {
                message.success('删除成功', 1, () => {
                    this.props.removeStuff(item);
                });
            } else {
                message.error(res.message);
            }
        });
    };

    viewStuff = (stuffId) => {
        this.setState({
            contentModalVisible: true,
            viewStuffId: stuffId
        })
    };

    closeModal = () => {
        this.setState({
            contentModalVisible: false
        })
    };

    render() {
        let summaryStyle = {
            textIndex: "2em",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            marginTop: "10px",
            color: '#a4adc8',
            fontSize: '14px',
        };
        return (
            <div>
                <Modal title={"内容详情"} destroyOnClose={true} visible={this.state.contentModalVisible} bodyStyle={{ height: "78vh" }} footer={null} onCancel={this.closeModal}>
                    <ContentModal materialId={this.state.materialId} viewStuffId={this.state.viewStuffId} />
                </Modal>
                <table width={"100%"} height={"100%"} style={{}}>
                    <tbody>
                        <tr style={{ height: "100px", padding: "10px" }}>
                            <td style={{ width: "150px", textAlign: "right" }}>
                                <img src={this.state.stuffList[0].titlePic} style={{objectFit:'cover'}} height={80} width={150}/>
                            </td>
                            <td style={{ padding: "10px", cursor: 'pointer' }} onClick={() => this.viewStuff(this.state.stuffList[0].id)}>
                                <div style={{ fontFamily: 'MicrosoftYaHei-Bold', fontSize: '15px', color: '#2a3a6b', fontWeight: 'bolder' }}>{this.state.stuffList[0].title}</div>
                                <div style={summaryStyle} >{this.state.stuffList[0].summary}</div>
                            </td>
                            <td style={{ width: "200px", textAlign: "center" }}>
                                <img src={time} alt="" />
                                <span style={{ fontFamily: 'MicrosoftYaHei-Bold', color: '#8792b3', paddingLeft: 10, position: 'relative', bottom: '-2px' }}>{window.formatDate(this.state.stuffList[0].updateDate)}</span>
                            </td>
                            <td style={{ width: "5%", textAlign: "center" }}>
                                {
                                    this.state.stuffList[0].statusName === '已删除' ? '已删除' :
                                        <Tooltip placement="top" title={"删除"}>
                                            <Popconfirm placement="right" title={"删除后用户将无法访问此图文，确定删除？该操作只能删除历史消息中的记录，不能删除已经成功发送到用户的消息。"} onConfirm={() => this.deleteStuff(this.state.stuffList[0])} okText="确认" cancelText="取消">
                                                {/* <Icon type="delete" style={{cursor:"pointer"}}/> */}
                                                <img src={del} style={{ cursor: "pointer" }} alt="" />
                                            </Popconfirm>
                                        </Tooltip>
                                }
                            </td>
                            <td style={{ width: "10%", textAlign: "center", borderTop: "1px solid #f4f6fc" }}>
                                <div className="view" style={{ fontFamily: 'MicrosoftYaHei-Bold', color: '#7c53c9', fontWeight: 'bolder', cursor: 'pointer', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center' }} onClick={() => window.open(`${this.state.stuffList[0].url}`, '_blank')}>
                                    <svg t="1604297739452" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3066" width="20" height="20"><path d="M864 640a32 32 0 0 1 64 0v224.096A63.936 63.936 0 0 1 864.096 928H159.904A63.936 63.936 0 0 1 96 864.096V159.904C96 124.608 124.64 96 159.904 96H384a32 32 0 0 1 0 64H192.064A31.904 31.904 0 0 0 160 192.064v639.872A31.904 31.904 0 0 0 192.064 864h639.872A31.904 31.904 0 0 0 864 831.936V640z m-485.184 52.48a31.84 31.84 0 0 1-45.12-0.128 31.808 31.808 0 0 1-0.128-45.12L815.04 166.048l-176.128 0.736a31.392 31.392 0 0 1-31.584-31.744 32.32 32.32 0 0 1 31.84-32l255.232-1.056a31.36 31.36 0 0 1 31.584 31.584L924.928 388.8a32.32 32.32 0 0 1-32 31.84 31.392 31.392 0 0 1-31.712-31.584l0.736-179.392L378.816 692.48z" fill="#7c53c9" p-id="3067"></path></svg></div>
                            </td>
                        </tr>

                        {
                            this.state.showStuffList ?
                                this.state.stuffList.map((item, index) => {
                                    if (index > 0) {
                                        return (
                                            <tr key={uuid()} style={{ height: "50px", padding: "5px" }}>
                                                <td style={{ width: "150px", textAlign: "right", borderTop: "1px solid #f4f6fc" }}>
                                                    <img src={item.titlePic} height={40} />
                                                </td>
                                                <td style={{ padding: "10px", borderTop: "1px solid #f4f6fc", cursor: 'pointer' }}>
                                                    <div>
                                                        <div style={{ fontFamily: 'MicrosoftYaHei-Bold', fontSize: '15px', color: '#2a3a6b', fontWeight: 'bolder' }} onClick={() => this.viewStuff(item.id)}>{item.title}</div>
                                                        <div style={summaryStyle}>{item.summary}</div>
                                                    </div>
                                                </td>
                                                <td style={{ width: "15%", textAlign: "center", borderTop: "1px solid #f4f6fc" }}>
                                                    <img src={time} alt="" />
                                                    <span style={{ fontFamily: 'MicrosoftYaHei-Bold', color: '#8792b3', paddingLeft: 10, position: 'relative', bottom: '-2px' }}> {window.formatDate(item.updateDate)}</span>
                                                </td>
                                                <td style={{ width: "5%", textAlign: "center", borderTop: "1px solid #f4f6fc" }}>
                                                    {
                                                        item.statusName === '已删除' ? '已删除' :
                                                            <Tooltip placement="top" title={"删除"}>
                                                                <Popconfirm placement="right" title={"删除后用户将无法访问此图文，确定删除？该操作只能删除历史消息中的记录，不能删除已经成功发送到用户的消息。"} onConfirm={() => this.deleteStuff(item)} okText="确认" cancelText="取消">
                                                                    {/* <Icon type="delete" style={{cursor:"pointer"}}/> */}
                                                                    <img src={del} style={{ cursor: "pointer" }} alt="" />
                                                                </Popconfirm>
                                                            </Tooltip>
                                                    }
                                                </td>
                                                <td style={{ width: "10%", textAlign: "center", borderTop: "1px solid #f4f6fc" }}>
                                                    <div className="view" style={{ fontFamily: 'MicrosoftYaHei-Bold', color: '#7c53c9', fontWeight: 'bolder', cursor: 'pointer', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center' }} onClick={() => window.open(`${item.url}`, '_blank')}>
                                                        <svg t="1604297739452" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3066" width="20" height="20"><path d="M864 640a32 32 0 0 1 64 0v224.096A63.936 63.936 0 0 1 864.096 928H159.904A63.936 63.936 0 0 1 96 864.096V159.904C96 124.608 124.64 96 159.904 96H384a32 32 0 0 1 0 64H192.064A31.904 31.904 0 0 0 160 192.064v639.872A31.904 31.904 0 0 0 192.064 864h639.872A31.904 31.904 0 0 0 864 831.936V640z m-485.184 52.48a31.84 31.84 0 0 1-45.12-0.128 31.808 31.808 0 0 1-0.128-45.12L815.04 166.048l-176.128 0.736a31.392 31.392 0 0 1-31.584-31.744 32.32 32.32 0 0 1 31.84-32l255.232-1.056a31.36 31.36 0 0 1 31.584 31.584L924.928 388.8a32.32 32.32 0 0 1-32 31.84 31.392 31.392 0 0 1-31.712-31.584l0.736-179.392L378.816 692.48z" fill="#7c53c9" p-id="3067"></path></svg> </div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                }) : <tr><td></td></tr>
                        }
                    </tbody>
                </table>
            </div>
        );
    }

}

export default PublishRecord;